<script setup lang="ts">
import { useKnowledgeApi } from '@/composables/api/useKnowledgeApi.ts'

const { t } = useI18n()

const open = defineModel<boolean>('open', { default: false })

withDefaults(
  defineProps<{ item?: string; secondaryActionPromise?: () => boolean | Promise<boolean> }>(),
  {
    item: '',
    secondaryActionPromise: () => true,
  },
)
const { isDeleting } = useKnowledgeApi()
const openModal = () => {
  open.value = true
}

const closeModal = () => {
  open.value = false
  return true
}
</script>

<template>
  <div>
    <OModal
      v-model:open="open"
      teleport
      :secondary-action-title="t('cancel')"
      :primary-action-title="t('delete_permanently')"
      :primary-action-enabled="!isDeleting"
      :secondary-action-enabled="!isDeleting"
      :secondary-action-promise="closeModal"
      :primary-action-promise="secondaryActionPromise"
      danger
      :title="t('confirm_deletion')"
    >
      <template #content>
        <i18n-t
          keypath="delete_document_content"
          tag="span"
          class="typography-body-2 text-neutral-1"
        >
          <span class="typography-body-2-strong">{{ item }}</span>
        </i18n-t>
      </template>
    </OModal>

    <slot :handle-click="openModal" />
  </div>
</template>
